import React, { useEffect, useState } from 'react';
import Spinner from 'components/loader/Spinner';
import useUpdateOrganization from '../hooks/useUpdateOrganization';
import { ModifyOrganizationInput } from 'types/Organization';
import { ModalProps } from 'types/Modal';
import { NButton, NDialog } from '@innersource-nn/novoui-react';
import NSelectTooltip from 'components/Inputs/InputsWithTooltip/NSelectTooltip';
import useCreateOrganization from '../hooks/useCreateOrganization';
import NTextAreaQuill from 'components/Inputs/TextAreaQuill/NTextAreaQuill';

const EditModal = ({ visible, onClose }: ModalProps) => {
    const { organization, contentLoading, handleSubmit, updating } =
        useUpdateOrganization();
    const { loading, adGroupOptions } = useCreateOrganization();
    const [formData, setFormData] = useState<ModifyOrganizationInput>({
        description: organization.description,
        SamlGroupName: organization.SamlGroupName,
    });

    useEffect(() => {
        setFormData({
            description: organization.description,
            SamlGroupName: organization.SamlGroupName,
        });
    }, [organization]);
    const handleClick = async () => {
        await handleSubmit(formData);
        if (onClose) onClose();
    };

    return (
        <NDialog
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline="Edit organization details"
            primaryLabel="Console"
            size="medium"
            showDividers={false}
        >
            <div>
                {contentLoading ? (
                    <Spinner />
                ) : (
                    <div className="flex flex-col gap-16">
                        <NTextAreaQuill
                            label="Organization description"
                            placeholder="Organization description..."
                            variant="outline"
                            modelValue={formData.description}
                            onChange={(value) =>
                                setFormData({
                                    ...formData,
                                    description: value,
                                })
                            }
                        />
                        <NSelectTooltip
                            content="Select the domain which is most relevant to the new dataset, if the domain does not exist please contact the datahub support team."
                            label="Organization admin name*"
                            size="medium"
                            variant="outline"
                            placeholder="Select an admin group"
                            options={adGroupOptions}
                            disabled={loading}
                            modelValue={formData.SamlGroupName}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    SamlGroupName: e.target.value,
                                })
                            }
                        />
                        <div className="flex justify-end">
                            <NButton
                                variant="fill"
                                size="small"
                                square
                                isLoading={updating}
                                onClick={handleClick}
                            >
                                Update organization
                            </NButton>
                        </div>
                    </div>
                )}
            </div>
        </NDialog>
    );
};
export default EditModal;
